import { render, staticRenderFns } from "./TvExport.vue?vue&type=template&id=c68dfeda&scoped=true"
import script from "./TvExport.vue?vue&type=script&lang=js"
export * from "./TvExport.vue?vue&type=script&lang=js"
import style0 from "./TvExport.vue?vue&type=style&index=0&id=c68dfeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68dfeda",
  null
  
)

export default component.exports